import $ from 'jquery';

const SELECTOR_IMAGE = '.js-background-image';
const SELECTOR_CURRENT = '.is-current';
const CLASS_CURRENT = 'is-current';

const $images = $(SELECTOR_IMAGE);

const getNextImage = () => {
  const $current = $images.filter(SELECTOR_CURRENT);
  if ($current.length <= 0) {
    return $images.first();
  }
  if ($current.next(SELECTOR_IMAGE).length >= 1) {
    return $current.next(SELECTOR_IMAGE);
  }
  return $images.first();
};

const setCurrentImage = ($image) => {
  $images.filter(SELECTOR_CURRENT).removeClass(CLASS_CURRENT);
  $image.addClass(CLASS_CURRENT);
};

if ($images.length >= 2) {
  setCurrentImage(getNextImage());
  setInterval(() => {
    const image = getNextImage();
    if (image) {
      setCurrentImage(image);
    }
  }, 5000);
}
